import React, { useEffect, useRef, useState } from 'react';

const InstagramWidget = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [iframeHeight, setIframeHeight] = useState('450px');

  useEffect(() => {
    const iframe = iframeRef.current;
    if (iframe) {
      // Function to handle iframe load and resize
      const handleLoad = () => {
        // Set initial height
        setIframeHeight('450px');
        
        // Try to auto-adjust height after a short delay
        setTimeout(() => {
          try {
            // Check if we can access iframe content (may fail due to CORS)
            const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
            if (iframeDoc) {
              const contentHeight = iframeDoc.body?.scrollHeight || 400;
              if (contentHeight > 200) {
                setIframeHeight(`${Math.max(contentHeight, 400)}px`);
              }
            }
          } catch (error) {
            // CORS restriction, keep default height
            console.log('Cannot access iframe content (CORS), using default height');
          }
        }, 1000);
      };
      
      iframe.addEventListener('load', handleLoad);
      
      // Set initial height immediately
      setIframeHeight('450px');
      
      // Cleanup
      return () => {
        iframe.removeEventListener('load', handleLoad);
      };
    }
  }, []);

  return (
    <div className="mt-8 pt-6 border-t border-gray-200">
      <h4 className="text-lg font-semibold text-gray-800 mb-6 text-center">
        🌟 Follow Kami di Instagram
      </h4>
      <div className="w-full flex justify-center">
        <div 
          className="w-full max-w-md mx-auto instagram-widget-container"
          style={{ 
            minHeight: iframeHeight,
            overflow: 'visible'
          }}
        >
          <iframe
            ref={iframeRef}
            src="//lightwidget.com/widgets/5f5bdd9d36f858b295a89a693d7fe9b3.html"
            scrolling="no"
            allowTransparency={true}
            className="w-full border-0 block lightwidget-widget rounded-lg shadow-md"
            style={{ 
              height: iframeHeight,
              minHeight: '450px',
              maxHeight: '600px',
              overflow: 'visible'
            }}
            loading="lazy"
            title="Instagram Widget - Follow @blisspa.halalhomespa"
          />
        </div>
      </div>
      
      {/* Fallback link in case iframe doesn't load */}
      <div className="mt-4 text-center">
        <a 
          href="https://www.instagram.com/blisspa.halalhomespa" 
          target="_blank" 
          rel="noopener noreferrer"
          className="inline-flex items-center px-4 py-2 text-sm font-medium text-[#70A681] bg-white/50 rounded-lg hover:bg-white/70 transition-all duration-300 shadow-sm border border-white/40"
        >
          📱 Visit @blisspa.halalhomespa
        </a>
      </div>
    </div>
  );
};

export default InstagramWidget;